import { render } from "./tablemasteritemp2h.vue?vue&type=template&id=4d96e169"
import script from "./tablemasteritemp2h.vue?vue&type=script&lang=js"
export * from "./tablemasteritemp2h.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__